module.exports = __webpack_public_path__ + "static/media/YF102_2.8ea91868.jpg";